/**
 * Trainerhonorar für eine Session in € (Vorschau / Abrechnung).
 * @param {{ honorar_type?: string, honorar_rate_eur?: number|string|null, honorar_amount_eur?: number|string|null, duration_min?: number|string|null }} s
 * @returns {number}
 */
export function computeSessionTrainerHonorarEur(s) {
  const typ = String(s?.honorar_type || "per_hour").trim();
  if (typ === "no_payout") return 0;
  if (typ === "flat_session") {
    const a = Number(s?.honorar_amount_eur);
    return Number.isFinite(a) && a > 0 ? a : 0;
  }
  if (typ === "per_hour" || typ === "custom") {
    const r = Number(s?.honorar_rate_eur);
    const mins = Number(s?.duration_min) || 0;
    if (!Number.isFinite(r) || r <= 0 || mins <= 0) return 0;
    return (mins / 60) * r;
  }
  return 0;
}
